import { useMemo } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { I18N_NAMESPACE } from "../../constants/i18n"

import * as Styled from "./SubNetworksSelector.styled"

export const SubNetworksSelector = (props) => {
    const {
        network,
        activeSubNetworks,
        onMouseEnter,
        onMouseLeave,
        onChange,
        onClose,
        ...PopoverProps
    } = props

    const { t } = useTranslation(I18N_NAMESPACE)

    const subnetworksOptions = useMemo(() => {
        const checkboxes = []
        const isIndeterminate = activeSubNetworks.length !== 0 && activeSubNetworks.length !== network.children.length
        checkboxes.push(
            <Styled.Checkbox
                key={network.slug}
                color="primary"
                indeterminate={isIndeterminate}
                label={t(I18N_NAMESPACE, "containers.networkSelector.allSubNetworks")}
                labelPosition="end"
                value={network.children.every((subnetwork) => activeSubNetworks.includes(subnetwork.slug))}
                onChange={(_, checked) => {
                    if (checked && !isIndeterminate) {
                        onChange(network.children.map((subnetwork => subnetwork.slug)))
                    } else {
                        onChange([])
                    }
                }}
                size="small"
                slotProps={{
                    typography: { variant: "Desktop & Mobile/Heading/H3" },
                }}
            />,
        )
        network.children.map((subnetwork) => (
            checkboxes.push(
                <Styled.Checkbox
                    key={subnetwork.slug}
                    color="primary"
                    labelPosition="end"
                    label={subnetwork.name}
                    value={activeSubNetworks.includes(subnetwork.slug)}
                    onChange={(_, checked) => {
                        if (checked) {
                            onChange([...activeSubNetworks, subnetwork.slug])
                        } else {
                            onChange(activeSubNetworks.filter((slug) => slug !== subnetwork.slug))
                        }
                    }}
                    size="small"
                />,
            )
        ))

        return checkboxes
    }, [network, activeSubNetworks, onChange, t])

    return <Styled.ContainerPopover
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
        slotProps={{
            paper: {
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                sx: { pointerEvents: "auto" },
            },
        }}
        onClose={() => {
            onClose?.(network, activeSubNetworks)
        }}
        {...PopoverProps}
    >
        <div sx={{ width: "100%", height: "100%" }}>
            <Styled.CheckboxContainer>
                {subnetworksOptions}
            </Styled.CheckboxContainer>
        </div>
    </Styled.ContainerPopover >
}

SubNetworksSelector.propTypes = {
    network: PropTypes.object.isRequired,
    activeSubNetworks: PropTypes.array.isRequired,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
}
